import { render, staticRenderFns } from "./pic.vue?vue&type=template&id=df34394e&scoped=true"
import script from "./pic.vue?vue&type=script&lang=js"
export * from "./pic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df34394e",
  null
  
)

export default component.exports